import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import styles from './index.module.scss';

interface NotAvailableStatus {
  label: string;
}

const NotAvailableStatus = ({ label }: NotAvailableStatus) => {
  return (
    <section className={styles.section}>
      <InfoOutlinedIcon style={{ fill: 'gray' }} />
      <div className={styles.label}>
        <span>{label}</span>
      </div>
    </section>
  );
};

export default NotAvailableStatus;
